import React, { PureComponent } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListAlt as faListAltSolid } from "@fortawesome/free-solid-svg-icons";
import { faListAlt } from "@fortawesome/free-regular-svg-icons";
import { IconButton } from "../styled-components/";

class DetailsListButton extends PureComponent {
  render() {
    return (
      <IconButton onClick={this.props.onClick}>
        <FontAwesomeIcon
          fixedWidth
          size="lg"
          icon={this.props.active ? faListAltSolid : faListAlt}
        />
      </IconButton>
    );
  }
}

DetailsListButton.defaultProps = {
  active: false
};

DetailsListButton.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default DetailsListButton;



// WEBPACK FOOTER //
// ./app/components/DetailsListButton.js